import { chakra, Box } from "@chakra-ui/react";
import { space } from "theme/themeConfig";
import { colours } from "@shared/ui.design-system";

export const Container = chakra(Box, {
  baseStyle: {
    pb: space["1"]
  }
});

export const ItemContainer = chakra(Box, {
  baseStyle: {
    pt: space["1"],
    mt: space["1"],
    borderTop: `1px solid ${colours.secondary.deep}`,
    position: "relative"
  }
});
